/** 频次标签别名 → 预设 key（与 routine_freq_presets.json 一致） */
export const ROUTINE_FREQ_ALIASES = {
  '1次/月': '月测',
  '每月1次': '月测',
  '一月一次': '月测',
  '1次每月': '月测',
  '每月': '月测',
  '月测1次': '月测',
  '季测1次': '季测',
  '每季1次': '季测',
  '1次/季': '季测',
  '1次/年': '1次/年',
  '一年一次': '1次/年',
  '年测': '1次/年',
  '1次/半年': '1次/半年',
  '半年一次': '1次/半年',
  '1次/半年测': '1次/半年',
  // 旧「2次/年」与「1次/半年」同为 2 期，保留别名兼容历史数据
  '2次/年': '1次/半年',
  '一年两次': '1次/半年',
  '2次每年': '1次/半年',
  '两次/年': '1次/半年',
  '日测': '日测',
  '1次/天': '日测',
  '每天1次': '日测',
  '一日一次': '日测',
  '365次/年': '日测',
  '一年365次': '日测'
}

const IGNORE_LABELS = new Set(['自定义', 'custom', '__custom__'])

export function parseRoutineSchedule(raw) {
  const sch = {}
  for (let m = 1; m <= 12; m++) sch[String(m)] = 0
  if (!raw) return sch
  let obj = raw
  if (typeof raw === 'string') {
    try { obj = JSON.parse(raw) } catch (e) { return sch }
  }
  if (!obj || typeof obj !== 'object') return sch
  for (let m = 1; m <= 12; m++) {
    const k = String(m)
    const v = obj[k] != null ? obj[k] : obj[m]
    sch[k] = (v === 1 || v === '1' || v === true) ? 1 : 0
  }
  return sch
}

export function scheduleHasMonth(sch) {
  if (!sch || typeof sch !== 'object') return false
  return Object.keys(sch).some(k => sch[k] === 1 || sch[k] === '1' || sch[k] === true)
}

export function schedulesEqual(a, b) {
  const sa = parseRoutineSchedule(a)
  const sb = parseRoutineSchedule(b)
  for (let m = 1; m <= 12; m++) {
    if (!!sa[String(m)] !== !!sb[String(m)]) return false
  }
  return true
}

export function resolveRoutinePresetKey(label, presets = {}) {
  const t = String(label || '').trim()
  if (!t || t === '__custom__' || IGNORE_LABELS.has(t)) return ''
  if (presets[t]) return t
  const aliased = ROUTINE_FREQ_ALIASES[t]
  if (aliased && presets[aliased]) return aliased
  return ''
}

/** 从排期 / 次期 反推预设 key */
export function inferRoutinePresetKey(row, presets = {}) {
  if (!row || !presets || typeof presets !== 'object') return ''
  const fromLabel = resolveRoutinePresetKey(row.freq_label, presets)
  if (fromLabel) return fromLabel

  const sched = parseRoutineSchedule(row.schedule_json)
  if (scheduleHasMonth(sched)) {
    for (const [key, p] of Object.entries(presets)) {
      if (p && p.schedule && schedulesEqual(sched, p.schedule)) return key
    }
  }

  const fc = parseInt(row.freq_count, 10) || 1
  const pc = parseInt(row.periods_count, 10) || 1
  const rawLabel = String(row.freq_label || '').trim()
  const byCount = Object.entries(presets).filter(([, p]) =>
    (parseInt(p.freq_count, 10) || 1) === fc && (parseInt(p.periods_count, 10) || 1) === pc
  )
  if (byCount.length > 1 && scheduleHasMonth(sched)) {
    const bySched = byCount.find(([key]) => schedulesEqual(sched, presets[key].schedule))
    if (bySched) return bySched[0]
  }
  // 仅 1 个预设匹配次/期，且非导入占位「自定义」、或有有效排期时，才用次期推断
  if (byCount.length === 1 && !IGNORE_LABELS.has(rawLabel) && (scheduleHasMonth(sched) || rawLabel)) {
    return byCount[0][0]
  }
  return ''
}

export function routinePresetOptionLabel(key, preset) {
  const fc = (preset && preset.freq_count) || 1
  const pc = (preset && preset.periods_count) || 1
  return `${key}（${fc}次/期，共${pc}期）`
}

/** 表单下拉用：库里的「自定义」→ __custom__，已知预设 → key */
export function normalizeFormFreqValue(label, presets = {}) {
  const t = String(label || '').trim()
  if (!t) return ''
  if (t === '__custom__' || IGNORE_LABELS.has(t)) return '__custom__'
  const key = resolveRoutinePresetKey(t, presets)
  if (key) return key
  if (presets[t]) return t
  return '__custom__'
}
